import { IExtendedCompany, ILCHttpResponse } from '@logicalcommander/types'
import { createApi } from '@reduxjs/toolkit/query/react'
import { v4 as uuidv4 } from 'uuid'
import { configManager } from '../../config/configManager'
import { RootState } from '../redux/store'
import { createBaseQueryWithErrorHandling } from './baseQueryWithErrorHandling'

export const extendedCompanyApi = createApi({
  reducerPath: 'extendedCompanyApi',
  baseQuery: createBaseQueryWithErrorHandling(`${configManager.api.GATEWAY_URL}/company`, (headers, { getState }) => {
    headers.set('x-request-id', uuidv4())
    const { token, companyToken } = (getState() as RootState).authReducer
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    if (companyToken) {
      headers.set('x-company-token', companyToken)
    }
    return headers
  }),
  endpoints: (builder) => ({
    getExtendedCompany: builder.query<IExtendedCompany, void>({
      query: () => ({
        url: 'extended',
      }),
      transformResponse: (rawResult: ILCHttpResponse<IExtendedCompany>, meta) => {
        return rawResult.data as IExtendedCompany
      },
    }),
  }),
})

export const { useLazyGetExtendedCompanyQuery } = extendedCompanyApi
